import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Sign } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const OPEN = { ok: true, mode: "off" };

// Aviso/bloqueio por operação (avaliação, intervenção, fotografias, partilha). Sem MIO Sign ativo não mostra nada.
export default function ConsentNotice({ patientId, op, onState }) {
  const { user } = useAuth();
  const [c, setC] = useState(null);
  useEffect(() => {
    if (!patientId) return;
    if (!user?.mio_sign_enabled) { onState?.(OPEN); return; }
    Sign.check(patientId, op).then((r) => { setC(r); onState?.(r); }).catch(() => onState?.(OPEN));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId, op, user?.mio_sign_enabled]);
  if (!c || c.ok || c.mode === "off") return null;
  const block = c.mode === "block";
  return (
    <div data-testid={`consent-notice-${op}`} data-mode={c.mode}
      className={`rounded-xl border p-3 text-sm flex gap-3 items-start ${block ? "border-rose-500/40 bg-rose-500/10 text-rose-200" : "border-amber-500/40 bg-amber-500/10 text-amber-100"}`}>
      <ShieldAlert className="w-4 h-4 shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        <div className="font-medium">{block ? "Indisponível até haver o documento assinado" : "Aviso de consentimento"}</div>
        <div className="text-xs opacity-90 mt-0.5">{c.message}</div>
        <Link to={`/patients/${patientId}#documentos`} data-testid={`consent-notice-${op}-sign`} className="inline-block mt-1.5 text-xs underline">
          Assinar agora
        </Link>
      </div>
    </div>
  );
}
